import { globalStyle, style, styleVariants } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

export const teamPitchElement = style({
  display: "flex",
  flexDirection: "column",
});

export const subTooltipWrap = style({
  display: "none",
  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      display: "flex",
    },
  },
});

export const subIcon = style({
  display: "block",
  cursor: "pointer",
  width: 16,
  height: 16,
  fill: vars.colors.white,
});

export const dreamTeamIcon = style({
  display: "block",
  cursor: "pointer",
  width: 10,
  height: 10,
  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      width: 16,
      height: 16,
      fill: vars.colors.white,
    },
  },
});

const captainIconBase = style({
  display: "block",
  width: 10,
  height: 10,
  color: vars.colors.white,
  fill: vars.colors.primaryFixed,
  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      width: 16,
      height: 16,
    },
  },
});

export const captainIconVariants = styleVariants({
  default: [captainIconBase],
  tripleC: [
    captainIconBase,
    {
      fill: vars.colors.white,
      color: vars.colors.primaryFixed,
    },
  ],
});

export const viceCaptainIconVariants = captainIconVariants;

const pitchElementWrapBase = style({
  position: "relative",
  margin: "auto",
  width: 67,
  height: 92,
  overflow: "hidden",
  "@media": {
    [`screen and (min-width:${breakpoints[2]})`]: {
      width: 112,
      height: 140,
    },
  },
});

export const pitchElementWrapVariants = styleVariants({
  "": [pitchElementWrapBase], // default
  instigator: [pitchElementWrapBase],
  target: [pitchElementWrapBase],
  invalid: [
    pitchElementWrapBase,
    {
      opacity: 0.4,
      transition: "all 0.15s",
      pointerEvents: "none",
    },
  ],
});

// Transition styles for instigator and target
globalStyle(
  `${pitchElementWrapVariants.instigator} [data-pitch-element="true"], ${pitchElementWrapVariants.target} [data-pitch-element="true"]`,
  {
    transition: "all 0.15s",
  },
);

globalStyle(
  `${pitchElementWrapVariants.instigator} [data-fixture-bar="true"], ${pitchElementWrapVariants.target} [data-fixture-bar="true"]`,
  {
    transition: "all 0.15s",
    borderRadius: 0,
  },
);

globalStyle(
  `${pitchElementWrapVariants.instigator} [data-element-name="true"], ${pitchElementWrapVariants.target} [data-element-name="true"]`,
  {
    transition: "all 0.15s",
    marginInlineStart: "0.1rem",
    marginInlineEnd: "0.1rem",
  },
);

// Instigator-specific styles
globalStyle(
  `${pitchElementWrapVariants.instigator} [data-pitch-element="true"]`,
  {
    border: `1px solid ${vars.colors.error}`,
    boxShadow: `inset 0 0 0 0.1rem ${vars.colors.error}`,
  },
);

globalStyle(
  `${pitchElementWrapVariants.instigator} [data-fixture-bar="true"]`,
  {
    borderRadius: 0,
    backgroundColor: vars.colors.error,
    color: vars.colors.white,
  },
);

// Target-specific styles
globalStyle(`${pitchElementWrapVariants.target} [data-pitch-element="true"]`, {
  border: `1px solid ${vars.colors.success}`,
  boxShadow: `inset 0 0 0 0.1rem ${vars.colors.success}`,
});

globalStyle(`${pitchElementWrapVariants.target} [data-fixture-bar="true"]`, {
  borderRadius: 0,
  backgroundColor: vars.colors.success,
  color: vars.colors.white,
});
